import type { ProviderPhoto, ProviderPhotoKey } from "@src/interfaces/provider-photo.interface";

export const buildProviderPhotoKey = ({ contextId, providerId }: ProviderPhotoKey): string => {
  return `${contextId}:${providerId}`;
};

export const isSupportedProviderPhotoContentType = (contentType?: string): boolean => {
  return /^image\/(png|jpe?g|gif|webp)$/i.test(contentType || "");
};

export const getProviderPhotoSrc = (providerPhoto?: ProviderPhoto): string | undefined => {
  if (
    !providerPhoto?.hasPhoto ||
    !providerPhoto.providerPhotoBase64 ||
    !isSupportedProviderPhotoContentType(providerPhoto.photoContentType)
  ) {
    return undefined;
  }

  return `data:${providerPhoto.photoContentType};base64,${providerPhoto.providerPhotoBase64}`;
};

export const getProviderPhotoMetadata = (
  providerPhoto?: ProviderPhoto,
): ProviderPhoto | undefined => {
  if (!providerPhoto) {
    return undefined;
  }

  const { providerPhotoBase64: _providerPhotoBase64, ...providerPhotoMetadata } = providerPhoto;

  return providerPhotoMetadata;
};
